import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/home/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recommendMessenger/home',
    exact: true,
    meta: {
      title: '邀请好友跑单赚现金'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/friendDetail/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendMessenger/friendDetail',
    meta: {
      title: '好友详情页'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/recommendList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendMessenger/recommendList',
    meta: {
      title: '推荐好友同城榜'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/invitationRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendMessenger/invitationRecord',
    meta: {
      title: '邀请记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/rewardRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendMessenger/rewardRecord',
    meta: {
      title: '奖励记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/ruleDetails/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendMessenger/ruleDetails',
    meta: {
      title: '活动规则'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recommendMessenger/recommendRegister/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recommendMessenger/recommendRegister',
    meta: {
      title: '闪送员注册'
    }
  }
]
